(function () {
    'use strict';

    angular
        .module('skillsApp')
        .controller('ChangeClusterActionClusterDialogController', ChangeClusterActionClusterDialogController);

    function ChangeClusterActionClusterDialogController($q, $uibModalInstance, $translate, logger, clusterAction, dataService, modalDialogService) {
        var vm = this;
        var allClusters = null;
                
        vm.cancel = cancel;
        vm.save = save;
        vm.updateClusters = updateClusters;

        $q.all([dataService.getClusterTypes(), dataService.getAllClusters()]).then(results => {
            var clusterTypes = results[0];

            allClusters = results[1] || [];

            vm.clusterType = _.find(clusterTypes, item => { return item.type.toLowerCase() === clusterAction.clusterType; });
            vm.clusterTypes = clusterTypes;

            updateClusters(clusterAction.clusterId);
        });


        function cancel() {
            $uibModalInstance.dismiss('cancel');
        }

        function save() {
            return dataService
                .changeClusterActionCluster(clusterAction.id, vm.cluster.id)
                .then(result => { $uibModalInstance.close(result.data); });
        }
        
        function updateClusters(clusterId) {
            var clusters = _.chain(allClusters)
                .filter(cluster => { return cluster.clusterType === vm.clusterType.type; })
                .sortBy(cluster => { return cluster.name.toLowerCase(); })
                .value();

            vm.cluster = clusterId ? _.find(clusters, item => { return item.id === clusterId; }) : clusters[0];
            vm.clusters = clusters;
        }
    }
})();
